// src/pages/Login.jsx
import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import { useNavigate } from 'react-router-dom';
import './Login.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);

    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    console.log('로그인 결과:', { data, error });

    if (error) {
      if (error.message === 'Invalid login credentials') {
        setError('이메일 또는 비밀번호를 확인해주세요.');
      } else if (error.message === 'Email not confirmed') {
        setError('이메일 인증이 완료되지 않았습니다. 메일함을 확인해주세요.');
      } else {
        setError('로그인 중 오류가 발생했습니다: ' + error.message);
      }
    } else {
      navigate('/');
    }
  };

  return (
    <div className="login-container">
      <h2 className="login-title">Login</h2>
      <form className="login-form" onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          className="login-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <div className="password-wrapper">
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="Password"
            className="login-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button
            type="button"
            className="toggle-btn"
            onClick={() => setShowPassword((prev) => !prev)}
          >
            {showPassword ? '🙈' : '🐵'}
          </button>
        </div>

        {error && <p className="login-error">{error}</p>}

        <button type="submit" className="login-button">
          로그인
        </button>

        <p className="login-signup-link">
          아직 계정이 없으신가요?{' '}
          <span onClick={() => navigate('/signup')} className="signup-link-text">
            회원가입
          </span>
        </p>
      </form>
    </div>
  );
}

export default Login;
